// extracted by mini-css-extract-plugin
export var box = "_5k-1";
export var checked = "_5k-2";
export var descriptionSpacer = "_5k-9";
export var disabled = "_5k-3";
export var icon = "_5k-6";
export var input = "_5k-0";
export var labelSpacer = "_5k-8";
export var medium = "_5k-5";
export var small = "_5k-4";
export var text = "_5k-7";